import { Component } from 'react'

export default class Shipments extends Component {
	render() {
		return <div className="page-content">Shipments</div>
	}
}
